const axios = require("axios");
const {
  //get auth token
  getAuth,
  //remove auth token
  removeToken,
} = require("./authenticate");
const { config1 } = require("../views/config");

const Axios = axios.create({
  baseURL: config1.API_HOST,
});


//set auth token in header

// Axios.defaults.headers.common["authorization"] = `Bearer ${token}`;

Axios.interceptors.request.use(
  config => {
    const token = getAuth();

    if (token != null) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

Axios.interceptors.response.use(
  (res) => {
    return res;
  },
  (err) => {
    // if (err.response.status === 401) {
    if (err) {
      //remove token
      removeToken();
      // console.log("need to log out");
      window.location.href = window.location.origin
    }
    return Promise.reject(err);
  }
  // }
);

export default Axios;
